<ng-container *appLoad="let notes of load$">
  <div class="notes">
    <!-- header -->
    <div class="notes__header">
      <div class="row">
        <!-- search -->
        <div class="col">
          <form [formGroup]="form">
            <lds-input
              formControlName="searchControl"
              identifier="searchControl"
              name="searchControl"
              placeholder="search note contents"
              iconPrefix="search">
            </lds-input>
          </form>
        </div>

        <!-- btns -->
        <div class="col-auto">
          <lds-button appearance="secondary" (click)="addNote()">
            Add Note
          </lds-button>
        </div>
      </div>
    </div>

    <!-- list of notes -->
    <div class="notes__list">
      <ng-container *ngIf="notes.length; else tplNoResults">
        <ng-container *ngFor="let note of notes">
          <!-- TODO: split out into own component [future release] -->

          <lds-card>
            <div class="note">
              <div class="note__details">
                <div class="row">
                  <div class="col">
                    <ng-container
                      *ngIf="
                        note.createdDate;
                        then withTimeStamp;
                        else withoutTimeStamp
                      ">
                    </ng-container>
                    <ng-template #withTimeStamp>
                      <span class="note__title"
                        >{{ note.summary }} -
                        {{
                          note.createdDate | date : 'yyyy-MM-dd'
                        }}</span
                      >
                    </ng-template>
                    <ng-template #withoutTimeStamp>
                      <span class="note__title">{{ note.summary }}</span>
                    </ng-template>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span
                      class="note__subtext"
                      [innerHtml]="note.details"></span>
                  </div>
                </div>
              </div>

              <div class="note__action">
                <app-context-menu [menuItems]="note.id | diaryNoteContextMenu:this">
                </app-context-menu>
              </div>
            </div>
          </lds-card>
        </ng-container>
      </ng-container>

      <!-- TODO: add empty status/messaging [future release] -->
      <!-- template / no results -->
      <ng-template #tplNoResults></ng-template>
    </div>
  </div>
</ng-container>
